module.exports = __webpack_public_path__ + "img/Ross.7c955f9f.jpeg";